import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { ResourceRequestAccessLevel } from '~/types';

export const RESOURCE_SUMMARY_COUNT_QUERY = gql`
  query resourcePlansSummaryForCurrentTenant(
    $filter: ResourcePlanFilter
    $requestAccessLevel: ResourceRequestAccessLevel
  ) {
    resourcePlansSummaryForCurrentTenant(
      filter: $filter
      requestAccessLevel: $requestAccessLevel
    ) {
      pendingCount
      toBeHiredCount
      proposedCount
      allocationRejectedCount
    }
  }
`;

const useResourcePlanSummaryCounts = ({
  resourcePlanFilter,
  requestAccessLevel = ResourceRequestAccessLevel.All
} = {}) => {
  const {
    loading,
    error,
    data: { resourcePlansSummaryForCurrentTenant = {} } = {},
    refetch
  } = useQuery(RESOURCE_SUMMARY_COUNT_QUERY, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      requestAccessLevel,
      filter: resourcePlanFilter
    }
  });

  return {
    loading,
    error,
    refetch,
    ...resourcePlansSummaryForCurrentTenant
  };
};

export default useResourcePlanSummaryCounts;
